module.exports = __webpack_public_path__ + "img/img_splan.d71947ac.png";